var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb p-0",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c(
            "div",
            { staticClass: "thumb-image" },
            [
              _c(
                "div",
                { staticClass: "prop-1-1" },
                [
                  _vm._t("item-image", [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile
                      }
                    })
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _vm.savingMoneyPercent > 0
                ? _c("div", { staticClass: "fs-saving d-none" }, [
                    _c("span", { staticClass: "text-white" }, [
                      _vm._v(
                        " -" + _vm._s(Math.floor(_vm.savingMoneyPercent)) + "% "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.getBadgeProperties, function(badge) {
                return _c(
                  "div",
                  {
                    key: "badge-" + badge.groupId + "-" + badge.id,
                    staticClass: "fs-badge position-absolute"
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: _vm.$translate(
                          "HuGVueTheme::SingleItemTheme.BadgeImg"
                        ),
                        alt: _vm.$translate(
                          "HuGVueTheme::SingleItemTheme.BadgeAltText"
                        )
                      }
                    })
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("store-special", [
            _vm.storeSpecial ||
            _vm.item.variation.bundleType === "bundle" ||
            _vm.item.item.itemType === "set"
              ? _c("item-store-special", {
                  attrs: {
                    "store-special": _vm.storeSpecial,
                    "recommended-retail-price": _vm.item.prices.rrp,
                    "variation-retail-price": _vm.item.prices.default,
                    "special-offer-price": _vm.item.prices.specialOffer,
                    "decimal-count": _vm.decimalCount,
                    "bundle-type": _vm.item.variation.bundleType,
                    "item-type": _vm.item.item.itemType
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content p-2" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title font-weight-bold",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0
                    },
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", { key: attribute.id }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "thumb-meta mt-2 d-flex flex-wrap flex-md-nowrap"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "availability-preview align-self-end small font-weight-bold py-2 pb-md-0"
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-circle",
                          class:
                            "availability-" +
                            _vm.item.variation.availability.id,
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 1
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability1"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 2
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability2"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 3
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability3"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 4
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability4"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 5
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability5"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 6
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability6"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 7
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability7"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 8
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability8"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 9
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability9"
                                  )
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.variation.availability.id == 10
                          ? _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$translate(
                                    "HuGVueTheme::ItemAvailability.Availability10"
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "prices flex-md-column align-items-center align-items-md-end"
                      },
                      [
                        _vm.item.prices.rrp &&
                        _vm.item.prices.rrp.price.value > 0 &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.price.value
                          ? _c("div", { staticClass: "price-view-port" }, [
                              _vm.item.prices.specialOffer
                                ? _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            true
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "price" },
                          [
                            _vm.item.item.itemType === "set"
                              ? [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          { price: _vm.itemSetPrice }
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              : _vm.itemGraduatedPriceisCheapestSorting
                              ? [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              : _vm.itemGraduatedPricesalableVariationCount
                              ? [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemFromPrice",
                                          { price: _vm.itemPriceGraduated }
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("specialOffer")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          _vm.item.prices,
                                          "unitPrice",
                                          "formatted"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                _vm._l(_vm.getAddTextProperties109, function(property) {
                  return _c("span", {
                    key: property.id,
                    staticClass:
                      "add-text d-inline-block small font-weight-bold p-2 my-2",
                    domProps: { innerHTML: _vm._s(property.values.value) }
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.getAddTextProperties111, function(property) {
                  return _c("span", {
                    key: property.id,
                    staticClass:
                      "add-text d-inline-block small font-weight-bold p-2 mb-2",
                    domProps: { innerHTML: _vm._s(property.values.value) }
                  })
                })
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }